import { render, staticRenderFns } from "./pricemoney-overview.vue?vue&type=template&id=3aaf993f&"
import script from "./pricemoney-overview.ts?vue&type=script&lang=ts&"
export * from "./pricemoney-overview.ts?vue&type=script&lang=ts&"
import style0 from "./pricemoney-overview.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VTextField})
